module.exports = __webpack_public_path__ + "static/img/IMG_20170303_150111.5f88ea96.jpg";